import { retornoHashValor } from '../../modulos/cripotografia/hash';
import api from '../backAxios';
import apiZelo from '../backAxiosVendaToken';

const url = retornoHashValor(process.env.REACT_APP_1);
const token = localStorage.getItem('token');
let retorno;

export const BuscarPromoCidade = async (exato, tipo, value) => {
    await fetch(`adesao-por-cidade/tabela-preco/filtro/${exato}?${tipo}=${value}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err;
        });

    return retorno;
};

//rota com regra de aplicar valores de belo horizontes para outras cidades casa não esteja cadastrada na tabela de preços
export const BuscarPromoCidadeTabelaPreco = async (exato, plano, value, tipo, subgrupo , pagina, itens) => {
    try {
        let query =`tipo=${plano}&&${tipo}=${value}`;

        query = (pagina) ? `${query}&&pagina=${pagina}` : query;

        query = (itens) ? `${query}&&itens=${itens}` : query;

        query = (subgrupo) ? `${query}&&plano=${subgrupo}` : query;

        const response = await api.get(
            `adesao-por-cidade/tabela-preco/filtro/${exato}?${query}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarPromoCidadePlanoTabelaPreco = async pagina => {
    try {
        let query = 'tipo=Plano';

        query = pagina ? `${query}&&pagina=${pagina}` : query;

        const response = await api.get(
            `adesao-por-cidade/tabela-preco/filtro/true?${query}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarTabelaPrecoAdesaoTodas = async pagina => {
    const query = pagina ? `pagina=${pagina}` : '';

    try {
        const response = await api.get(
            `adesao-por-cidade/tabela-preco/filtro/true?${query}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const BuscarPlanosCidade = async cidade => {
    try {
        const response = await api.get(
            `adesao-por-cidade/nome/v2/${cidade}`
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const savePromocao = async value => {
    try {
        const response = await apiZelo.post(`${url}/adesao-por-cidade`, value);

        return response;
    } catch (error) {
        console.log(error);
    }
};

export const UpdatePromocao = async value => {
    await fetch(`${url}/adesao-por-cidade`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        },
        body: JSON.stringify(value)
    })
        .then(resp => resp.json())
        .then(respJson => {
            retorno = respJson;
        })
        .catch(err => {
            console.log(err);
        });

    return retorno;
};

export const updateStatusPlano = async (data, newStatus) =>{
    try {
        const response = newStatus === 1? await apiZelo.put('tabela-preco/adesao/ativar', data) : await apiZelo.delete('tabela-preco/adesao/desativar', { data });

        return response;
    } catch (error) {
        throw new Error(error.response.data?.mensagem || error.response.statusText);
    }
};

export const UpdatePromocaoMensalidade = async (id, data) => {
    try {
        const response = await api.put(
            `${url}/adesao-por-cidade/tabela-preco/${id}`,
            data
        );

        return response.data;
    } catch (error) {
        return error.message;
    }
};

export const ListaLogs = async id => {
    await fetch(`${url}/tabela-preco/log/modificacao-plano/${id}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token
        }
    })
        .then(response => response.json())
        .then(responseJson => {
            if (responseJson) {
                retorno = responseJson;
            } else {
                retorno = { erro: 'parametros errados' };
            }
        })
        .catch(err => {
            retorno = err;
        });

    return retorno;
};

export const excluirPromocao = async objetoEdicao =>{
    try {
        const response = await apiZelo.put('/adesao-por-cidade/desconto/desativar', objetoEdicao);

        return response;
    } catch (error) {
        console.log(error);
    }
};
